import Vue from "vue"
import VueRouter from "vue-router"
import Store from "../store/index"

import TaskPage from "../components/TaskPage"
import MainPage from "../components/MainPage"


Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "MainPage",
    component: MainPage,
    meta: {
      needAuth: true,
    }
  },
  {
    path: "/task",
    name: "TaskPage",
    component: TaskPage,
    meta: {
      needAuth: true,
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(
  function(to, from, next) {
    let vvuuee = Vue
    Store.commit("update", {
      key: "previous_page",
      value: from
    });
    Store.commit("incRouterPageCounter");
    if (to.meta.needAuth) {
      const refresh = vvuuee.$cookies.get("token");
      let warningText= "Необходимо залогиниться";
      if (!refresh) {
        if (from.name === "SignIn") {
          vvuuee.swal({ "icon": "warning", "text":  warningText});
          return false;
        }
        next({ name: "SignIn" });
        vvuuee.swal({ "icon": "warning", "text": warningText});
      } else {
        next();
      }
    }
    next();
  }
);

export default router;
